var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{class:_vm.isMobile ? 'wrapper-mobile' : 'wrapper'},[(_vm.show)?_c('iframe',{attrs:{"src":"https://email.contasinfinity.com.br/mailbox","frameborder":"0"}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }